module.exports = __webpack_public_path__ + "static/media/asignatura8.03d6859f.png";